import { render, staticRenderFns } from "./ModalEmployeeCatering.vue?vue&type=template&id=65109921&scoped=true&"
import script from "./ModalEmployeeCatering.vue?vue&type=script&lang=js&"
export * from "./ModalEmployeeCatering.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmployeeCatering.vue?vue&type=style&index=0&id=65109921&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65109921",
  null
  
)

export default component.exports